import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import DropDownInputField from "../../components/forms/DropDownInputField";
import FormError from "../../components/forms/FormError";

class AddAccountForm extends Component {

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field
              label="Account Name"
              name="name"
              placeholder="Personal Account"
              component={TextInputField}
              serverError={this.props.errors.name}
              />
            <Field 
              label="Shipping Destination"
              name="jurisdictionId"
              component={DropDownInputField}
              data={this.props.territories}
              valueKey="id"  
              titleKey="name" 
              showBlank={true}
              serverError={this.props.errors.jurisdictionId}
              />
          </FormFieldsTable>
        </div>  
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "AddAccountForm"
})(AddAccountForm);

export default ReduxForm;